import type { ConnectEmailMethod } from '@/constants';
import { gtmConnectEmailSuccess } from './gtmEmailSync';

type GtmConnectEmailGateArgs = {
  method: ConnectEmailMethod;
  variant?: string;
  // HTTP status of the reply; undefined for login replies that carry no status
  status?: number;
  // reply opt-in flag: `user_info.email_sync_opt_in` or `realtime_sync_activated`
  optIn?: boolean;
  // reply flag `ems_first_grant`; missing = false
  emsFirstGrant?: boolean;
};

const isNon2xx = (status?: number) => status !== undefined && (status < 200 || status >= 300);

// Fires connect_email_success only for a 2xx reply with opt-in true. Wraps only the GTM call.
export const gtmConnectEmailSuccessIfGranted = ({
  method,
  variant,
  status,
  optIn,
  emsFirstGrant,
}: GtmConnectEmailGateArgs): boolean => {
  if (isNon2xx(status) || optIn !== true) {
    return false;
  }
  gtmConnectEmailSuccess(method, emsFirstGrant === true, variant);
  return true;
};
